import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/fleet-portal/')({
    beforeLoad: ({ params }): ShareableRouteContext => {
        throw redirect({ to: '/console/$orgId/fleet-portal/dashboard', params, replace: true });
    },
});
